export const deletePaymentLinkMutation = ({ payment_link_id }) => ({
  url: `/link-pagamento/${payment_link_id}`,
  method: "delete",
});
